import {formatAmountValue, formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetails, DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {getBranchName, getDisplayId} from "./documentData.function";

// the hours of the timesheet, in this order; a total of 0 is left out
const HOURS_FIELDS: [keyof DocumentDetails, string][] = [
    ["regularHours", "documentData.regularHours"],
    ["overtimeHours", "documentData.overtimeHours"],
    ["otherHours", "documentData.otherHours"],
    ["invoiceOtherHours", "documentData.invoiceOtherHours"],
    ["invoiceOvertimeHours", "documentData.invoiceOvertimeHours"],
    ["totalHours", "documentData.totalHours"],
    ["totalInvoiceHours", "documentData.invoiceTotalHours"],
];

const TimesheetDocumentDetailsDTO = ({details, translate}: DocumentDetailsProps) => {
    const branchName = getBranchName(details);

    return (
        <DocumentDataGrid>
            {details.description &&
                <DocumentDataField id="description" wide label={translate("documentData.description")}
                                   value={details.description}/>}
            {details.submitterName &&
                <DocumentDataField id="submitterName" label={translate("documentData.submitterName")}
                                   value={details.submitterName}/>}
            {branchName &&
                <DocumentDataField id="branch" label={translate("documentData.branch")} value={branchName}/>}
            {details.type &&
                <DocumentDataField id="type" label={translate("documentData.type")} value={details.type}/>}
            <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
            {!!details.weekNumber &&
                <DocumentDataField id="weekNumber" label={translate("documentData.weekNumber")} value={details.weekNumber}/>}
            {!!details.weekStart &&
                <DocumentDataField id="weekStart" label={translate("documentData.weekStart")}
                                   value={formatDate(details.weekStart, null)}/>}
            {!!details.weekEnd &&
                <DocumentDataField id="weekEnd" label={translate("documentData.weekEnd")}
                                   value={formatDate(details.weekEnd, null)}/>}
            {HOURS_FIELDS.map(([key, label]) => details[key] ?
                <DocumentDataField key={key} id={key} label={translate(label)} value={formatAmountValue(details[key])}/> :
                null)}
            {details.documentOrganizationUnit &&
                <DocumentDataField id="organizationUnit" label={translate("documentData.organizationUnit")}
                                   value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>}
        </DocumentDataGrid>
    );
};

export default TimesheetDocumentDetailsDTO;
